import React, { useEffect } from "react";

// nodejs library that concatenates classes
import classNames from "classnames";

import { useTranslation } from 'react-i18next';

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import styles from "assets/jss/material-kit-react/views/termsAndConditionsPage.js";

const useStyles = makeStyles(styles);

const TermsAndConditionsPage = props => {
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    const { ...rest } = props;

    useEffect(() => {
        window.scrollTo(0,0);
    }, []);

    return (
        <>
            <Header
                fixed
                color="primary"
                {...rest}
            />

            <GridContainer className={classes.main}>
                <GridItem className={classes.section}>
                    <h1 className={classes.title}>
                        {t('terms.title')}
                    </h1>
                    <p className={classNames(classes.info, classes.topMargin, classes.noBottomMargin)}>
                        {t('terms.address')}
                    </p>
                    <address className={classes.info}>
                        {t('terms.address-1')} <br />
                        {t('terms.address-2')} <br />
                        {t('terms.address-3')} <br />
                        {t('terms.address-4')}
                    </address>
                    <p className={classNames(classes.info, classes.topMargin)}>
                        {t('terms.contact')} <br />
                        {t('terms.email')} <br />
                        {t('terms.tel')}
                    </p>
                    <p className={classes.info}>
                        {t('terms.content')} <br />
                        {t('terms.management')}
                    </p>

                    <h2 className={classes.sectionTitle}>
                        {t('terms.section-1-title')}
                    </h2>
                    <p className={classes.info}>
                        {t('terms.section-1-1')}
                    </p>
                    <p className={classes.info}>
                        {t('terms.section-1-2')}
                    </p>
                    <p className={classes.info}>
                        {t('terms.section-1-3')}
                    </p>

                    <h2 className={classes.sectionTitle}>
                        {t('terms.section-2-title')}
                    </h2>
                    <p className={classes.info}>
                        {t('terms.section-2-1')}
                    </p>
                    <p className={classes.info}>
                        {t('terms.section-2-2')}
                    </p>
                    {t('terms.section-2-3') && 
                    <ul>
                        <li className={classes.info}>
                            {t('terms.section-2-3')}
                        </li>
                        <li className={classes.info}>
                            {t('terms.section-2-4')}
                        </li>
                        <li className={classes.info}>
                            {t('terms.section-2-5')}
                        </li>
                        <li className={classes.info}>
                            {t('terms.section-2-6')}
                        </li>
                    </ul>
                    }
                    <p className={classes.info}>
                        {t('terms.section-2-7')}
                    </p>

                    <h2 className={classes.sectionTitle}>
                        {t('terms.section-3-title')}
                    </h2>
                    <p className={classes.info}>
                        {t('terms.section-3-1')}
                    </p>

                    <h2 className={classes.sectionTitle}>
                        {t('terms.section-4-title')}
                    </h2>
                    <p className={classes.info}>
                        {t('terms.section-4-1')}
                    </p>

                    <h2 className={classes.sectionTitle}>
                        {t('terms.section-5-title')}
                    </h2>
                    <p className={classes.info}>
                        {t('terms.section-5-1')}
                    </p>
                    <p className={classes.info}>
                        {t('terms.section-5-2')}
                    </p>

                    <h2 className={classes.sectionTitle}>
                        {t('terms.section-6-title')}
                    </h2>
                    <p className={classes.info}>
                        {t('terms.section-6-1')}
                    </p>
                </GridItem>
            </GridContainer>

            <Footer />
        </>
    );
};

export default TermsAndConditionsPage;